import { render } from "./CubeDetails.vue?vue&type=template&id=32b5eda1&scoped=true"
import script from "./CubeDetails.vue?vue&type=script&lang=js"
export * from "./CubeDetails.vue?vue&type=script&lang=js"

import "./CubeDetails.vue?vue&type=style&index=0&id=32b5eda1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b5eda1"]])

export default __exports__